import React, { Component } from 'react';

import './App.css';

import Slide from './components/Slider';
import Navigation from './components/Navigation.jsx';

import Alert from './assets/img/alert.png';
import HowDoesItWork from './assets/img/how_does_it_work.png';
import Offers from './assets/img/offers.png';
import QRCode from './assets/img/QR_code.png';
import Redeem from './assets/img/redeem.png';
import Stores from './assets/img/stores.png';

import SwipeableViews from 'react-swipeable-views';

import MetaTags from 'react-meta-tags';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      index: 0
    }
  }

  handleChange = (event, value) => {
    this.setState({
      index: value,
    });
  }

  handleChangeIndex = index => {
    this.setState({
      index,
    });
  }

  switchNext = () => {
    if (this.state.index < 5) {
      this.setState({index: this.state.index + 1})
    } else {
      window.location.href = 'gmalite://gmalite-news';
    }
  }

  switchFromNav = (index) => {
    this.setState({
      index
    });
  }

  render() {
    return (
      <div className="App">
        <MetaTags>
          <title>Uitleg App</title>
          <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no shrink-to-fit=no" />
        </MetaTags>
        <SwipeableViews index={this.state.index} onChangeIndex={this.handleChangeIndex}>
          <Slide current={this.state.currentSlide} img={HowDoesItWork} title='Aan de slag' buttonText='Volgende'>
            Hier lees je over alle mogelijkheden binnen de app. Van uitleg over de Coupons tot het vinden van een McDonald’s restaurant in de buurt.
          </Slide>
          <Slide current={this.state.currentSlide} img={Offers} title='Altijd voordeel' buttonText='Volgende'>
            Met onze Coupons kun je extra voordelig genieten van je favoriete McDonalds’s producten!
          </Slide>
          <Slide current={this.state.currentSlide} img={Redeem} title='Hoe werken de Coupons?' buttonText='Volgende'>
            De Coupons in onze app kun je in bijna al onze restaurants gebruiken. Je kunt de Coupon maar 1x gebruiken en hij is 10 minuten geldig. Activeer hem dus als je bij de kiosk of kassa staat. 
          </Slide>
          <Slide current={this.state.currentSlide} img={QRCode} title='Scannen van QR-code' buttonText='Volgende'>
            Nadat je de Coupon activeert, verschijnt er een QR-code. Scan 'm bij de kiosk of aan de kassa zodat 'ie aan je bestelling wordt toegevoegd. Soms helpt het om de code tussen de 10 en 30 cm van de scanner te houden. Je zou 'm ook even kunnen bewegen of kantelen.
          </Slide>
          <Slide current={this.state.currentSlide} img={Stores} title='Restaurant in de buurt' buttonText='Volgende!'>
            Met de restaurant finder zie je in no time waar het dichtstbijzijnde restaurant zich bevindt. Inclusief openingstijden, voorzieningen en routebeschrijving. Handig!
          </Slide>
          <Slide current={this.state.currentSlide} img={Alert} title='Er is meer...' buttonText='Klaar!'>
            Naast de Coupons komt deze app van pas als je onze menukaart wilt bekijken. Of op de hoogte wilt blijven van leuke aanbiedingen en acties. En heb je nog vragen? Laat ’t ons dan even weten!
          </Slide>
        </SwipeableViews>
        <Navigation active={this.state.index} text={this.state.index < 5 ? 'Volgende' : 'Klaar!'} onClickButton={this.switchNext} onClickNav={this.switchFromNav} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js